var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.filterExist)?_c('certificates-new-filters-index',{attrs:{"filters":_vm.filters,"type":"registrations"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }